module.exports = __webpack_public_path__ + "media/img/logos/2024/jobboerse-stellenangebote-berufseinsteiger-weltumwelttag-fb805affd9bfaff043047d7c8acdcdf3.svg";